/**
 * Similar to https://github.com/chenqingspring/react-lottie/blob/master/src/index.js
 * Using functional React and the lottie lite-player
 */
import React, { useRef, useEffect } from "react";
import lottieLight from "lottie-web/build/player/lottie_light"; // 164kb - compared to 264kb for non-light.
import { AnimationItem } from "lottie-web";

export interface RequiredImplementingProps {
    onComplete: () => void;
    onAnimationStart: () => void;
}

interface LottieProps extends RequiredImplementingProps {
    animationData: any;
    loop: boolean;
}

function Lottie({ animationData, loop, onComplete, onAnimationStart }: LottieProps): JSX.Element {
    let lottieElementRef = useRef<HTMLDivElement>(null);
    let lottiePlayerRef = useRef<null | AnimationItem>(null);
    useEffect(() => {
        if (lottieElementRef.current == null) {
            return;
        }

        lottiePlayerRef.current = lottieLight.loadAnimation({
            container: lottieElementRef.current,
            animationData,
            loop: loop,
            autoplay: true,
        });

        lottiePlayerRef.current.addEventListener("complete", onComplete);
        onAnimationStart();
        return (): void => {
            lottiePlayerRef.current?.removeEventListener("complete", onComplete);
            lottiePlayerRef.current?.destroy();
        };
    }, [animationData, loop, onComplete, onAnimationStart]);

    return <div ref={lottieElementRef}></div>;
}

export default Lottie;
